'use client';

import TrackedLinksIconSvg from '@/assets/svgs/jobs/job-tracked-links-filled.svg';
import PlusIconSvg from '@/assets/svgs/plus.svg';
import { NEW_JOB_ID } from '@/containers/Jobs/constants';
import { selectTrackedLinks } from '@/containers/Jobs/redux/jobEditors.selectors';
import { Modals } from '@/containers/Modals/all-modals';
import { useAppDispatch } from '@/lib/redux/store';
import classNames from 'classnames';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import ModalBody from '../ModalBody';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import { addOpenModal } from '../redux/modals.slice';
import { ModalProps, ViewTrackedLinksModalParams } from '../types';
import useModals from '../useModals';
import TrackedLinksList from './TrackedLinksList';

interface ViewTrackedLinksModalProps extends ModalProps {
  params?: ViewTrackedLinksModalParams;
}

const ViewTrackedLinksModal = ({
  className,
  params,
  variant = 'default',
}: ViewTrackedLinksModalProps) => {
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { onClose, isModalOpen } = useModals({
    modalName: Modals.ViewTrackedLinksModal,
  });

  // Modal Specific details
  const dispatch = useAppDispatch();
  const trackedLinks = useSelector(selectTrackedLinks(NEW_JOB_ID));
  const { allowInsertion } = params || {};

  return (
    <div className={classNames('relative', className)}>
      <input
        type="checkbox"
        id={Modals.ViewTrackedLinksModal}
        className="modal-toggle"
        checked={isModalOpen}
        onChange={() => {}}
      />
      <ModalContainer
        isModalOpen={isModalOpen}
        modalName={Modals.ViewTrackedLinksModal}
        isSearchEmpty={true}
        variant={variant}
        onClose={onClose}
        shouldCloseOnEscape>
        <div className="flex h-full flex-col">
          {/* Stick to top */}
          <ModalHeader
            modalName={Modals.ViewTrackedLinksModal}
            closeAction="state"
            icon={<TrackedLinksIconSvg className="h-5 w-5" />}
            title="Tracked Links"
          />

          {/* Take up remaining space and enable inside-scrolling */}
          <ModalBody ref={modalBodyRef} className="px-5 !py-0">
            {/* Action button */}
            <div className="flex h-[84px] items-center justify-end">
              <button
                className="btn btn-primary btn-sm flex gap-1 pl-1.5"
                onClick={() => {
                  dispatch(
                    addOpenModal({
                      modalName: Modals.AddTrackedLinkModal,
                      modalVariant: 'narrow',
                      modalParams: JSON.stringify({
                        jobId: NEW_JOB_ID,
                        allowInsertion: allowInsertion,
                      }),
                    })
                  );
                }}>
                <PlusIconSvg className="h-5 w-5" />
                Add a link
              </button>
            </div>
            <TrackedLinksList
              jobId={NEW_JOB_ID}
              links={trackedLinks}
              className="w-full"
              showEmptyContent
              allowInsertion={allowInsertion}
              onInsert={onClose}
            />
          </ModalBody>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button onClick={onClose}>close</button>
        </form>
      </ModalContainer>
    </div>
  );
};

export default ViewTrackedLinksModal;
